module.exports = __webpack_public_path__ + "static/media/running-logo-light.8a9d9190.png";